import { render, staticRenderFns } from "./TenderCardActionsRow.vue?vue&type=template&id=2c7a490c&"
import script from "./TenderCardActionsRow.vue?vue&type=script&lang=js&"
export * from "./TenderCardActionsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports